import axios from "axios"

export default () => ({
  opened: false,
  paused: false,
  timeout: 30,
  timer: null,
  intervalPaused: false,
  timeoutDisplay() {
    return this.timeout != 1 ? this.timeout + ' seconds' : this.timeout + ' second'
  },
  open() {
    this.opened = true
    document.body.style.overflow = 'hidden'
  },
  close() {
    if(this.opened) {
      this.opened = false
      document.body.style.overflow = 'initial'
    }
  },
  logout() {
    window.location = '/logout'
  },
  stay() {
    axios.post('/recent-activity')
    clearTimeout(this.timer)
    this.close()
    this.intervalPaused = false
  },
  init() {

    let timeSinceLastCheck = 0
    this.intervalPaused = false

    setInterval(() => {
      if (document.hasFocus() && !this.intervalPaused) {

        if(timeSinceLastCheck >= 60) {
          this.intervalPaused = true

          axios.get('/recent-activity').then(response => {

            if (response.data.logged_in === false) {
              this.logout()
              return;
            }

            if (response.data.has_recent_activity === false) {
              this.open()
              this.timeout = 30
              this.timer = setInterval(() => {
                this.timeout--
                if (this.timeout <= 0) {
                  this.logout()
                  clearInterval(this.timer);
                }
              }, 1000);
            } else {
              this.intervalPaused = false
            }

          })

          timeSinceLastCheck = 0
        }
      }

      if(!this.intervalPaused) {
        timeSinceLastCheck++;
      }
    }, 1000)

  }
})
